<template>
  <div class="form-upload">
    <x-proxy-form-item
    :showRequired="showRequired"
    :label="widget.label"
    :processTitle="widget.processTitle"
    :validatorRules="validatorRules"
    :validateKey="validateKey"
    :validateInfo="validateInfo"
    :disabled="widget.readOnly">
      <x-upload
        v-model="uploadValue"
        ref="xUpload"
        :click="false"
        :renderSence="renderSence"
        :uploadLimit="widget.fileMaxSize"
        :uploadNumber="uploadNumber"
        :uploadType="fileType"
        :readOnly="widget.readOnly"
        :postUpload="postUploadProxy"
        :beforeRemove="beforeRemove"
        :beforeUpload="beforeUpload"
        :removeUpload="removeUpload"
        @download="handleDownload"
        @cancal-upload="cancalUploadFile"
      ></x-upload>
    </x-proxy-form-item>
    <div class="form-upload-suffix" :class="{ 'is-fixed': uploadValue && uploadValue.length > 0 || loadingStack.length > 0 }" v-if="canUpload" @click="handleClick">
      <x-svg-icon name="x-lib-upload"></x-svg-icon>
    </div>
  </div>
</template>

<script>
import FormWidgetConfigMixin from '../../../mixins/form-widget.mixin'
import XUpload from '../../x-upload/x-upload'
import { mapAdapter } from '../form-build-action'
import { isWechat } from '../../../utils/platform.util.js'

export default {
  name: 'FormUpload',
  mixins: [FormWidgetConfigMixin],
  components: {
    XUpload
  },
  inject: ['$compRouter'],
  data() {
    return {
      loadingStack: []
    }
  },
  computed: {
    canUpload() {
      return this.renderSence === 'edit' && !this.widget.readOnly
        ? (!this.widget.fileMaxNum || this.widget.fileMaxNum === -1) 
          ? true 
          : this.formValue
            ? this.formValue.length < this.widget.fileMaxNum 
            : true
        : false
    },
    uploadNumber() {
      return (!this.widget.fileMaxNum || this.widget.fileMaxNum === -1) ? Infinity : this.widget.fileMaxNum
    },
    uploadValue: {
      get() {
        return this.formValue && this.formValue.map(item => {
          return {
            ...item,
            src: this.getImgSrc(item)
          } 
        })
      },
      set(value) {
        this.formValue = value.map(item => {
          delete item.src
          if (item.status === 'completed') {
            delete item.uuid
          }
          return item
        })
      }
    },
    fileType() {
      return this.widget.fileType.indexOf('all') === -1 ? this.widget.fileType : null
    }
  },
  created() {
    this.widgetRules = [this._validate((rule, value, callback) => {
      return this.loadingStack.length === 0 ? callback() : callback(new Error('请等待附件上传'))
    })]
  },
  methods: {
    ...mapAdapter(['postUpload', 'removeUpload', 'getImgSrc']),
    beforeRemove(file) {
      return new Promise((resolve, reject) => {
        this.$confirm({
          message: '是否确定删除该文件？',
          okConfig: {
            onOk() {
              resolve()
            }
          },
          cancelConfig: {
            onCancel() {
              reject()
            }
          }
        })
      })
    },
    handleClick() {
      if (!this.widget.readOnly) {
        this.$refs.xUpload && this.$refs.xUpload.chooseFile()
      }
    },
    handleDownload(file) {
      if (isWechat()) {
        this.$compRouter.push(this.$options.name, {
          key: this.propKey,
          widgetConfig: this.widget,
          value: file
        })
      } else {
        window.open(file.src + '&download=download', '_self')
      }
    },
    beforeUpload() {
      this.loadingStack.push(true)
    },
    postUploadProxy(file) {
      return new Promise((resolve, reject) => {
        this.postUpload(file).then(data => {
          resolve({
            ...data,
            src: this.getImgSrc(data)
          })
          this.loadingStack.pop()
        }, (err) => {
          reject(err)
        }).catch(err => {
          reject(err)
        }) 
      }) 
    },
    cancalUploadFile(data) {
      if (this.widget.abort[data.uuid] && this.widget.abort[data.uuid] instanceof Function) {
        this.widget.abort[data.uuid]('hide-message')
        this.loadingStack.pop()
        this.$refs.xUpload.emitFormValue(data.uuid)
      }
    }
  }
}
</script>

<style lang="scss">
.form-upload {
  position: relative;
  display: flex;
  align-items: center;
  .x-proxy-form-item {
    padding-right: 0;
  }
  .form-upload-suffix {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 0 0 3.43rem;
    width: 3.43rem;
    height: calc(100% - 1.71rem);
    font-size: 0;
    color: $--app-base-font-color;
    height: 100%;
    &.is-fixed {
      height: 3.43rem;
    }
  }
}
</style>